import { el } from 'redom';

import application from 'application';

import { stringToSVG } from 'utilities';

import attachmentIconString from 'assets/images/attachment-icon.svg?raw';

import './index.scss';

const attachmentIcon = stringToSVG(attachmentIconString);

class AddAttachmentButton {

  constructor(configuration) {

    this.onAttachment = configuration.onAttachment;

    this.el = el('button.attachment-button', {
      onclick: this.handleClick.bind(this)
    }, [
      attachmentIcon.cloneNode(true)
    ]);

  }

  async handleClick(event) {

    event.preventDefault();
    event.stopPropagation();

    const result = await application.domUtility.askAnyTypeFile();

    if (result.cancelled === true) {
      return;
    }

    this.onAttachment(result.file);

  }

  update(configuration) {

    this.onAttachment = configuration.onAttachment;

  }

}

export default AddAttachmentButton;